"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var config_1 = require("./config");
var urlHelper_1 = require("./utils/urlHelper");
var validation_error_response_1 = require("./models/validation-error-response");
var payloadTransformers_1 = require("./utils/payloadTransformers");
var formTools_1 = require("./utils/formTools");
var dataConverter_1 = require("./utils/dataConverter");
var audio_playlist_1 = require("./models/audio-playlist");
var audio_track_1 = require("./models/audio-track");
var video_playlist_1 = require("./models/video-playlist");
var video_track_1 = require("./models/video-track");
var error_reponse_1 = require("./models/error-reponse");
var ApiClient = /** @class */ (function () {
    function ApiClient() {
        this.jwt = null;
        this.config = {
            url: '',
            s3Url: '',
            s3PhotoRewrite: null,
        };
    }
    ApiClient.prototype.setJwtToken = function (token) {
        this.jwt = token;
    };
    ApiClient.prototype.clearJwtToken = function () {
        this.jwt = null;
    };
    ApiClient.prototype.getJwtToken = function () {
        return this.jwt;
    };
    ApiClient.prototype.setConfig = function (config) {
        var _a;
        this.config = __assign(__assign({}, this.config), config);
        urlHelper_1.default.setUrl(this.config.s3Url);
        urlHelper_1.default.setPhotoRewrite((_a = this.config.s3PhotoRewrite) !== null && _a !== void 0 ? _a : null);
    };
    ApiClient.prototype.getConfig = function () {
        return this.config;
    };
    ApiClient.prototype.isDebugMode = function () {
        return !!this.getConfig().debug;
    };
    ApiClient.prototype.generateRequestString = function (requestArgs) {
        if (requestArgs === void 0) { requestArgs = {}; }
        var query = Object.keys(requestArgs)
            .filter(function (key) { return !!requestArgs[key]; })
            .map(function (key) { return key + "=" + requestArgs[key]; })
            .join('&');
        return query ? "?" + query : '';
    };
    ApiClient.prototype.doesResponseContainMembers = function (response) {
        return !!response.data && response.data['hydra:member'] && response.data['hydra:member'] instanceof Array && response.data['hydra:member'].length > 0;
    };
    ApiClient.prototype.parsePageDataFromResponse = function (response) {
        if (!response['hydra:view'] || !response['hydra:view']['hydra:last']) {
            return {};
        }
        var matches = response['hydra:view']['hydra:last'].match(/.*page=(\d+)/);
        if (!matches || matches.length < 2) {
            return {};
        }
        var pagesCount = parseInt(matches[1], 10);
        var pagePrefix = matches[0].replace(new RegExp("=" + pagesCount + "$"), '=');
        return { pagesCount: pagesCount, pagePrefix: pagePrefix };
    };
    ApiClient.prototype.getConnectionEndpoint = function (from, to) {
        if (config_1.CONNECTION_ENDPOINT_MAP.hasOwnProperty(from['@type'])) {
            return config_1.CONNECTION_ENDPOINT_MAP[from['@type']];
        }
        if (config_1.CONNECTION_ENDPOINT_MAP.hasOwnProperty(to['@type'])) {
            return config_1.CONNECTION_ENDPOINT_MAP[to['@type']];
        }
        return config_1.CONNECTION_ENDPOINT_MAP.default;
    };
    ApiClient.prototype.getChangeRequestConnections = function (iri, type, orderField, orderDirection, endpoint) {
        if (type === void 0) { type = null; }
        if (orderField === void 0) { orderField = 'id'; }
        if (orderDirection === void 0) { orderDirection = 'desc'; }
        if (endpoint === void 0) { endpoint = '/change_request_connections'; }
        return __awaiter(this, void 0, void 0, function () {
            var response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request(endpoint + "?" + (type ? "entity[" + iri + "]=" + type : "entity=" + iri) + "&pagination=false&itemsPerPage=999999&order[" + orderField + "]=" + orderDirection)];
                    case 1:
                        response = _a.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        if (!this.doesResponseContainMembers(response)) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, dataConverter_1.createChangeRequestConnectionListFromData(response.data['hydra:member'], iri)];
                    case 2:
                        err_1 = _a.sent();
                        this.handleResponseException(err_1);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.getPaginatedChangeRequestConnections = function (iri, type, orderField, orderDirection, page, limit) {
        if (type === void 0) { type = null; }
        if (orderField === void 0) { orderField = 'id'; }
        if (orderDirection === void 0) { orderDirection = 'desc'; }
        if (page === void 0) { page = 1; }
        if (limit === void 0) { limit = null; }
        return __awaiter(this, void 0, void 0, function () {
            var response, _a, pagesCount, pagePrefix, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request("/change_request_connections?" + (type ? "entity[" + iri + "]=" + type : "entity=" + iri) + "&order[" + orderField + "]=" + orderDirection + "&page=" + page + "&itemsPerPage=" + (limit || 30))];
                    case 1:
                        response = _b.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        if (!this.doesResponseContainMembers(response)) {
                            return [2 /*return*/, {
                                    items: [],
                                    totalEntitiesCount: 0,
                                    pagesCount: 0,
                                    pagePrefix: '',
                                }];
                        }
                        _a = this.parsePageDataFromResponse(response.data), pagesCount = _a.pagesCount, pagePrefix = _a.pagePrefix;
                        return [2 /*return*/, {
                                items: dataConverter_1.createChangeRequestConnectionListFromData(response.data['hydra:member'], iri),
                                totalEntitiesCount: response.data['hydra:totalItems'] || 0,
                                pagesCount: pagesCount,
                                pagePrefix: pagePrefix,
                            }];
                    case 2:
                        err_2 = _b.sent();
                        this.handleResponseException(err_2);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.getChangeRequestConnectionsByChangeRequest = function (changeRequestId, entityIri, leftTypeFilter, rightTypeFilter, orderField, orderDirection, endpoint, itemsPerPage) {
        if (leftTypeFilter === void 0) { leftTypeFilter = null; }
        if (rightTypeFilter === void 0) { rightTypeFilter = null; }
        if (orderField === void 0) { orderField = 'id'; }
        if (orderDirection === void 0) { orderDirection = 'desc'; }
        if (endpoint === void 0) { endpoint = '/change_request_connections'; }
        if (itemsPerPage === void 0) { itemsPerPage = 999999; }
        return __awaiter(this, void 0, void 0, function () {
            var query, url, response, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = {
                            // api platform still limits the numbers of the items,
                            // when pagination=false, so have to set itemsPerPage high
                            itemsPerPage: itemsPerPage,
                            'changeRequest.id': changeRequestId,
                        };
                        query["order[" + orderField + "]"] = orderDirection;
                        if (leftTypeFilter) {
                            query.leftType = leftTypeFilter;
                        }
                        if (rightTypeFilter) {
                            query.rightType = rightTypeFilter;
                        }
                        url = endpoint + "?" + new URLSearchParams(query).toString();
                        return [4 /*yield*/, this.request(url, 'GET')];
                    case 1:
                        response = _a.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        if (!this.doesResponseContainMembers(response)) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, dataConverter_1.createChangeRequestConnectionListFromData(response.data['hydra:member'], entityIri)];
                    case 2:
                        err_3 = _a.sent();
                        this.handleResponseException(err_3);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.getConnections = function (iri, type, orderField, orderDirection) {
        if (type === void 0) { type = null; }
        if (orderField === void 0) { orderField = 'id'; }
        if (orderDirection === void 0) { orderDirection = 'desc'; }
        return __awaiter(this, void 0, void 0, function () {
            var response, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request("/connections?" + (type ? "entity[" + iri + "]=" + type : "entity=" + iri) + "&pagination=false&itemsPerPage=999999&order[" + orderField + "]=" + orderDirection)];
                    case 1:
                        response = _a.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        if (!this.doesResponseContainMembers(response)) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, dataConverter_1.createConnectionListFromData(response.data['hydra:member'], iri)];
                    case 2:
                        err_4 = _a.sent();
                        this.handleResponseException(err_4);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.getPaginatedConnections = function (iri, type, orderField, orderDirection, page, limit) {
        if (type === void 0) { type = null; }
        if (orderField === void 0) { orderField = 'id'; }
        if (orderDirection === void 0) { orderDirection = 'desc'; }
        if (page === void 0) { page = 1; }
        if (limit === void 0) { limit = null; }
        return __awaiter(this, void 0, void 0, function () {
            var response, _a, pagesCount, pagePrefix, err_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request("/connections?" + (type ? "entity[" + iri + "]=" + type : "entity=" + iri) + "&order[" + orderField + "]=" + orderDirection + "&page=" + page + "&itemsPerPage=" + (limit || 30))];
                    case 1:
                        response = _b.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        if (!this.doesResponseContainMembers(response)) {
                            return [2 /*return*/, {
                                    items: [],
                                    totalEntitiesCount: 0,
                                    pagesCount: 0,
                                    pagePrefix: '',
                                }];
                        }
                        _a = this.parsePageDataFromResponse(response.data), pagesCount = _a.pagesCount, pagePrefix = _a.pagePrefix;
                        return [2 /*return*/, {
                                items: dataConverter_1.createConnectionListFromData(response.data['hydra:member'], iri),
                                totalEntitiesCount: response.data['hydra:totalItems'] || 0,
                                pagesCount: pagesCount,
                                pagePrefix: pagePrefix,
                            }];
                    case 2:
                        err_5 = _b.sent();
                        this.handleResponseException(err_5);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.getEntityConnectionsCount = function (entitiyId) {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint, response, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        endpoint = "/entities/" + entitiyId + "/connections_count";
                        return [4 /*yield*/, this.request(endpoint, 'GET')];
                    case 1:
                        response = _a.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, response.data];
                    case 2:
                        err_6 = _a.sent();
                        this.handleResponseException(err_6);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.getPaginatedEntityConnectionsByEntity = function (entityId, page, limit, orderField, orderDirection, types, name) {
        if (page === void 0) { page = 1; }
        if (limit === void 0) { limit = 64; }
        if (orderField === void 0) { orderField = null; }
        if (orderDirection === void 0) { orderDirection = 'ASC'; }
        if (types === void 0) { types = null; }
        if (name === void 0) { name = null; }
        return __awaiter(this, void 0, void 0, function () {
            var query, endpoint, response, _a, pagesCount, pagePrefix, err_7;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        query = {
                            itemsPerPage: limit,
                            page: page,
                        };
                        if (orderField) {
                            query["order[" + orderField + "]"] = orderDirection;
                        }
                        if (types) {
                            query.types = types.join(',');
                        }
                        if (name) {
                            query.name = name;
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        endpoint = "/entities/" + entityId + "/connections?" + new URLSearchParams(query).toString();
                        return [4 /*yield*/, this.request(endpoint, 'GET')];
                    case 2:
                        response = _b.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        if (!this.doesResponseContainMembers(response)) {
                            return [2 /*return*/, {
                                    items: [],
                                    totalEntitiesCount: 0,
                                    pagesCount: 0,
                                    pagePrefix: '',
                                }];
                        }
                        _a = this.parsePageDataFromResponse(response.data), pagesCount = _a.pagesCount, pagePrefix = _a.pagePrefix;
                        return [2 /*return*/, {
                                items: dataConverter_1.createEntityConnectionFromData(response.data['hydra:member']),
                                totalEntitiesCount: response.data['hydra:totalItems'] || 0,
                                pagesCount: pagesCount || 1,
                                pagePrefix: pagePrefix || '',
                            }];
                    case 3:
                        err_7 = _b.sent();
                        this.handleResponseException(err_7);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.saveChangeRequestConnectionsOrder = function (data) {
        if (data === void 0) { data = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response, err_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request('/change_request_connections/order', 'PUT', JSON.stringify(data))];
                    case 1:
                        response = _a.sent();
                        if (204 === response.status) {
                            return [2 /*return*/, true];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_8 = _a.sent();
                        this.handleResponseException(err_8);
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.updateChangeRequestConnection = function (iri, connectionData, isDescriptionSame, connectionOfEntityIri) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request(iri, 'PUT', JSON.stringify(payloadTransformers_1.prepareConnectionPayload(connectionData, isDescriptionSame)))];
                    case 1:
                        response = _a.sent();
                        if (200 !== response.status) {
                            throw new Error('Invalid response status code.');
                        }
                        return [2 /*return*/, dataConverter_1.createChangeRequestConnectionFromData(response.data, connectionOfEntityIri)];
                    case 2:
                        err_9 = _a.sent();
                        this.handleResponseException(err_9);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.createChangeRequestConnection = function (changeRequest, from, to, connectionData, isDescriptionSame, overrideType) {
        if (connectionData === void 0) { connectionData = {}; }
        if (isDescriptionSame === void 0) { isDescriptionSame = false; }
        return __awaiter(this, void 0, void 0, function () {
            var payload, endpoint, response, responseData, err_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = __assign(__assign({}, payloadTransformers_1.prepareConnectionPayload(connectionData, isDescriptionSame)), { changeRequest: changeRequest['@id'], left: from['@id'], right: to['@id'], leftType: from['@type'], rightType: to['@type'] });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        endpoint = overrideType && config_1.CONNECTION_ENDPOINT_MAP[overrideType] ? config_1.CONNECTION_ENDPOINT_MAP[overrideType] : this.getConnectionEndpoint(from, to);
                        return [4 /*yield*/, this.request(endpoint, 'POST', JSON.stringify(payload))];
                    case 2:
                        response = _a.sent();
                        if (201 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        responseData = __assign(__assign({}, response.data), { left: from, right: to });
                        return [2 /*return*/, dataConverter_1.createChangeRequestConnectionFromData(responseData, from['@id'])];
                    case 3:
                        err_10 = _a.sent();
                        this.handleResponseException(err_10);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.createUser = function (name, email, password, confirmPassword, roles, activatedAt, newsletter, token) {
        if (roles === void 0) { roles = ['ROLE_USER']; }
        if (activatedAt === void 0) { activatedAt = null; }
        if (newsletter === void 0) { newsletter = false; }
        return __awaiter(this, void 0, void 0, function () {
            var data, response, err_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        data = {
                            name: name,
                            email: email,
                            plainPassword: password,
                            confirmPassword: confirmPassword,
                            newsletter: newsletter,
                            roles: roles,
                        };
                        if (activatedAt) {
                            data.isActive = true;
                            data.activatedAt = activatedAt;
                        }
                        return [4 /*yield*/, this.request('/users', 'POST', JSON.stringify(data), undefined, token)];
                    case 1:
                        response = _a.sent();
                        if (201 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, dataConverter_1.createUserFromData(response.data)];
                    case 2:
                        err_11 = _a.sent();
                        return [2 /*return*/, this.handleValidationErrorException(err_11)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.fetchUser = function (userId, token) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request("/users/" + userId, 'GET', undefined, undefined, token || this.jwt)];
                    case 1:
                        response = _a.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, dataConverter_1.createUserFromData(response.data)];
                    case 2:
                        err_12 = _a.sent();
                        return [2 /*return*/, this.handleValidationErrorException(err_12)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.updateUser = function (userId, data, $token) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request("/users/" + userId, 'PUT', JSON.stringify(data), undefined, $token)];
                    case 1:
                        response = _a.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, dataConverter_1.createUserFromData(response.data)];
                    case 2:
                        err_13 = _a.sent();
                        return [2 /*return*/, this.handleValidationErrorException(err_13)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.deleteUser = function (userId, token) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_14, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request("/users/" + userId, 'DELETE', undefined, undefined, token)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        err_14 = _a.sent();
                        if (err_14.response && err_14.response.data) {
                            error = err_14.response.data.error;
                            return [2 /*return*/, new error_reponse_1.ErrorResponse({
                                    code: error || err_14 || 500,
                                    message: error.message || err_14 || 'Ismeretlen hiba történt',
                                })];
                        }
                        return [2 /*return*/, new error_reponse_1.ErrorResponse({
                                code: err_14 || 500,
                                message: err_14 || 'Ismeretlen hiba történt',
                            })];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.fetchAuthorUsers = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request("/users/authors", 'GET', undefined, undefined, this.jwt)];
                    case 1:
                        response = _a.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        if (!this.doesResponseContainMembers(response)) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, dataConverter_1.createUsersFromDataArray(response.data['hydra:member'])];
                    case 2:
                        err_15 = _a.sent();
                        return [2 /*return*/, this.handleValidationErrorException(err_15)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.getPaginatedUsers = function (requestArgs) {
        if (requestArgs === void 0) { requestArgs = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getPaginatedModels('/users', requestArgs, this.jwt)];
            });
        });
    };
    ApiClient.prototype.requestForgotPasswordToken = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request('/forgot_password/', 'POST', JSON.stringify({ email: email }), undefined, null)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, 204 === response.status];
                    case 2:
                        err_16 = _a.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.updateForgotPassword = function (token, password) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request("/forgot_password/" + token, 'POST', JSON.stringify({ password: password }), undefined, null)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, 204 === response.status];
                    case 2:
                        err_17 = _a.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.verifyUserByToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_18;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request("/verify_user/" + token, 'POST')];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, 200 === response.status];
                    case 2:
                        err_18 = _a.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.uploadFile = function (endpoint, data, config) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(endpoint, 'POST', data, config)];
                    case 1:
                        response = _a.sent();
                        if (201 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, dataConverter_1.createEntityFromData(response.data)];
                }
            });
        });
    };
    ApiClient.prototype.createEntity = function (type, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_19;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!config_1.ENDPOINT_MAP.hasOwnProperty(type)) {
                            throw new Error('Endpoint could not find for entity type.');
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.request(config_1.ENDPOINT_MAP[type], 'POST', JSON.stringify(formTools_1.convertEmptyValuesToNull(data)))];
                    case 2:
                        response = _a.sent();
                        if (201 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, dataConverter_1.createEntityFromData(response.data)];
                    case 3:
                        err_19 = _a.sent();
                        this.handleResponseException(err_19);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.createChangeRequest = function (iri) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_20;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request(iri + "/change_requests", 'POST', JSON.stringify({}))];
                    case 1:
                        response = _a.sent();
                        if (201 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, dataConverter_1.createEntityFromData(response.data)];
                    case 2:
                        err_20 = _a.sent();
                        this.handleResponseException(err_20);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.updateEntity = function (iri, data) {
        return __awaiter(this, void 0, void 0, function () {
            var responseData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.update(iri, data)];
                    case 1:
                        responseData = _a.sent();
                        if (!responseData) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, dataConverter_1.createEntityFromData(responseData)];
                }
            });
        });
    };
    ApiClient.prototype.updateEntityChangeRequest = function (iri, data) {
        return __awaiter(this, void 0, void 0, function () {
            var responseData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.update(iri, data)];
                    case 1:
                        responseData = _a.sent();
                        if (!responseData) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, dataConverter_1.createEntityChangeRequestFromData(responseData)];
                }
            });
        });
    };
    ApiClient.prototype.updateEntityChangeRequestImage = function (iri, data, config) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(iri, 'POST', data, config)];
                    case 1:
                        response = _a.sent();
                        if (201 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, dataConverter_1.createEntityChangeRequestFromData(response.data)];
                }
            });
        });
    };
    ApiClient.prototype.updateZeneszovegMeta = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request('/zeneszoveg/' + id, 'GET', null, undefined, this.jwt)];
                    case 1:
                        response = _a.sent();
                        if (response.status < 400) {
                            return [2 /*return*/, response.data];
                        }
                        throw new Error(response.data || 'Ismertelen hiba');
                }
            });
        });
    };
    ApiClient.prototype.update = function (iri, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_21;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request(iri, 'PUT', data instanceof FormData ? data : JSON.stringify(formTools_1.convertEmptyValuesToNull(data)))];
                    case 1:
                        response = _a.sent();
                        if (200 !== response.status) {
                            throw new Error('Invalid response status code.');
                        }
                        return [2 /*return*/, response.data];
                    case 2:
                        err_21 = _a.sent();
                        this.handleResponseException(err_21);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.cloneEntity = function (id, fromChangeRequest) {
        if (fromChangeRequest === void 0) { fromChangeRequest = false; }
        return __awaiter(this, void 0, void 0, function () {
            var sourceType, response, err_22;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        sourceType = fromChangeRequest ? 'entity_change_requests' : 'entities';
                        return [4 /*yield*/, this.request("/" + sourceType + "/" + id + "/clone", 'POST')];
                    case 1:
                        response = _a.sent();
                        if (response.data) {
                            return [2 /*return*/, dataConverter_1.createEntityFromData(response.data)];
                        }
                        throw new Error('Hibás válasz érkezett');
                    case 2:
                        err_22 = _a.sent();
                        this.handleResponseException(err_22);
                        throw err_22;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.generatePriorityForType = function (type) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_23;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request('/priority_order', 'POST', { type: type })];
                    case 1:
                        response = _a.sent();
                        if (201 !== response.status) {
                            throw new Error('Invalid response status code.');
                        }
                        return [2 /*return*/, response.data];
                    case 2:
                        err_23 = _a.sent();
                        this.handleResponseException(err_23);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.getConvertedVideoUrls = function (iri) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_24;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request(iri + "/convert_status")];
                    case 1:
                        response = _a.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        if ('completed' !== response.data.status) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, response.data.data];
                    case 2:
                        err_24 = _a.sent();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.getByIri = function (iri) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_25;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request(iri)];
                    case 1:
                        response = _a.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, dataConverter_1.createEntityFromData(response.data)];
                    case 2:
                        err_25 = _a.sent();
                        this.handleResponseException(err_25);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.deleteByIri = function (iri) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_26;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request(iri, 'DELETE')];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, 204 === response.status];
                    case 2:
                        err_26 = _a.sent();
                        this.handleResponseException(err_26);
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.searchEntities = function (searchTerm, endpoint, searchParameter, itemsPerPage, options) {
        if (endpoint === void 0) { endpoint = '/entities'; }
        if (searchParameter === void 0) { searchParameter = 'name'; }
        if (itemsPerPage === void 0) { itemsPerPage = 999999; }
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var queryObj, url, response, err_27;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryObj = __assign(__assign({}, options), { itemsPerPage: itemsPerPage, 
                            // api platform still limits the numbers of the items
                            // when pagination=false, so have to set itemsPerPage high
                            pagination: false });
                        queryObj[searchParameter] = searchTerm;
                        url = endpoint + "?" + new URLSearchParams(queryObj).toString();
                        return [4 /*yield*/, this.request(url)];
                    case 1:
                        response = _a.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        if (!this.doesResponseContainMembers(response)) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, dataConverter_1.createEntityListFromData(response.data['hydra:member'])];
                    case 2:
                        err_27 = _a.sent();
                        this.handleResponseException(err_27);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.getLatestEntities = function (itemsPerPage) {
        if (itemsPerPage === void 0) { itemsPerPage = 9; }
        return __awaiter(this, void 0, void 0, function () {
            var response, err_28;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request("/entities?latest&pagination=false&itemsPerPage=" + itemsPerPage)];
                    case 1:
                        response = _a.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        if (!this.doesResponseContainMembers(response)) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, dataConverter_1.createEntityListFromData(response.data['hydra:member'])];
                    case 2:
                        err_28 = _a.sent();
                        this.handleResponseException(err_28);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.getPaginatedEntities = function (type, requestArgs) {
        if (requestArgs === void 0) { requestArgs = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var requestQueryString, endpoint, response, _a, pagesCount, pagePrefix, err_29;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!config_1.ENDPOINT_MAP.hasOwnProperty(type)) {
                            throw new Error('Endpoint could not find for entity type.');
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        requestQueryString = this.generateRequestString(requestArgs);
                        endpoint = "" + config_1.ENDPOINT_MAP[type] + requestQueryString;
                        return [4 /*yield*/, this.request(endpoint)];
                    case 2:
                        response = _b.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        if (!this.doesResponseContainMembers(response)) {
                            return [2 /*return*/, null];
                        }
                        _a = this.parsePageDataFromResponse(response.data), pagesCount = _a.pagesCount, pagePrefix = _a.pagePrefix;
                        return [2 /*return*/, {
                                items: dataConverter_1.createEntityListFromData(response.data['hydra:member']),
                                totalEntitiesCount: response.data['hydra:totalItems'] || 0,
                                pagesCount: pagesCount,
                                pagePrefix: pagePrefix,
                            }];
                    case 3:
                        err_29 = _b.sent();
                        this.handleResponseException(err_29);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.getPaginatedFavorites = function (requestArgs, jwtToken) {
        if (requestArgs === void 0) { requestArgs = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getPaginatedModels('/favorites', requestArgs, jwtToken)];
            });
        });
    };
    ApiClient.prototype.createFavorite = function (entity, jwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.createModel('/favorites', { entity: entity }, jwtToken)];
            });
        });
    };
    ApiClient.prototype.deleteFavorite = function (entity, jwtToken) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var favoriteResponse, favoriteItem, err_30;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getPaginatedFavorites({ entity: entity }, jwtToken)];
                    case 1:
                        favoriteResponse = _b.sent();
                        favoriteItem = (_a = favoriteResponse === null || favoriteResponse === void 0 ? void 0 : favoriteResponse.items[0]) !== null && _a !== void 0 ? _a : null;
                        if (!favoriteItem) {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, this.deleteModel(favoriteItem['@id'], jwtToken)];
                    case 2:
                        err_30 = _b.sent();
                        if (this.isDebugMode()) {
                            console.log('ERR! apiClient.deleteFavorite exception', err_30);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    ApiClient.prototype.getPaginatedAudioPlaylists = function (requestArgs, jwtToken) {
        if (requestArgs === void 0) { requestArgs = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getPaginatedModels('/audio_playlists', requestArgs, jwtToken)];
            });
        });
    };
    ApiClient.prototype.getAudioPlaylist = function (id, requestArgs, jwtToken) {
        if (requestArgs === void 0) { requestArgs = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getModel("/audio_playlists/" + id, requestArgs, jwtToken)];
                    case 1:
                        response = _a.sent();
                        if (null === response) {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, new audio_playlist_1.AudioPlaylist(response)];
                }
            });
        });
    };
    ApiClient.prototype.createAudioPlaylist = function (name, isPublic, jwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createModel('/audio_playlists', { name: name, public: isPublic }, jwtToken)];
                    case 1:
                        response = _a.sent();
                        if (false === response) {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, new audio_playlist_1.AudioPlaylist(response)];
                }
            });
        });
    };
    ApiClient.prototype.updateAudioPlaylist = function (id, name, isPublic, jwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/audio_playlists/" + id, 'PUT', { name: name, public: isPublic }, {}, jwtToken)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, 200 === response.status];
                }
            });
        });
    };
    ApiClient.prototype.deleteAudioPlaylist = function (id, jwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.deleteModel("/audio_playlists/" + id, jwtToken)];
            });
        });
    };
    ApiClient.prototype.getPaginatedAudioTracks = function (requestArgs, jwtToken) {
        if (requestArgs === void 0) { requestArgs = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getPaginatedModels('/audio_tracks', requestArgs, jwtToken)];
            });
        });
    };
    ApiClient.prototype.createAudioTrack = function (playlistIri, audioIri, jwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createModel('/audio_tracks', { playlist: playlistIri, audio: audioIri }, jwtToken)];
                    case 1:
                        response = _a.sent();
                        if (false === response) {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, new audio_track_1.AudioTrack(response)];
                }
            });
        });
    };
    ApiClient.prototype.getAudioTrack = function (id, requestArgs, jwtToken) {
        if (requestArgs === void 0) { requestArgs = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getModel("/audio_tracks/" + id, requestArgs, jwtToken)];
                    case 1:
                        response = _a.sent();
                        if (null === response) {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, new audio_playlist_1.AudioPlaylist(response)];
                }
            });
        });
    };
    ApiClient.prototype.deleteAudioTrack = function (id, jwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.deleteModel("/audio_tracks/" + id, jwtToken)];
            });
        });
    };
    ApiClient.prototype.updateAudioTracksOrder = function (items, jwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_31;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request('/audio_tracks/order', 'PUT', { items: items }, undefined, jwtToken)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, 204 === response.status];
                    case 2:
                        err_31 = _a.sent();
                        if (this.isDebugMode()) {
                            console.log('ERR! apiClient.updateAudioTracksOrder exception', err_31);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    ApiClient.prototype.getPaginatedVideoPlaylists = function (requestArgs, jwtToken) {
        if (requestArgs === void 0) { requestArgs = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getPaginatedModels('/video_playlists', requestArgs, jwtToken)];
            });
        });
    };
    ApiClient.prototype.getVideoPlaylist = function (id, requestArgs, jwtToken) {
        if (requestArgs === void 0) { requestArgs = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getModel("/video_playlists/" + id, requestArgs, jwtToken)];
                    case 1:
                        response = _a.sent();
                        if (null === response) {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, new video_playlist_1.VideoPlaylist(response)];
                }
            });
        });
    };
    ApiClient.prototype.createVideoPlaylist = function (name, isPublic, jwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createModel('/video_playlists', { name: name, public: isPublic }, jwtToken)];
                    case 1:
                        response = _a.sent();
                        if (false === response) {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, new video_playlist_1.VideoPlaylist(response)];
                }
            });
        });
    };
    ApiClient.prototype.updateVideoPlaylist = function (id, name, isPublic, jwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/video_playlists/" + id, 'PUT', { name: name, public: isPublic }, {}, jwtToken)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, 200 === response.status];
                }
            });
        });
    };
    ApiClient.prototype.deleteVideoPlaylist = function (id, jwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.deleteModel("/video_playlists/" + id, jwtToken)];
            });
        });
    };
    ApiClient.prototype.getPaginatedVideoTracks = function (requestArgs, jwtToken) {
        if (requestArgs === void 0) { requestArgs = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getPaginatedModels('/video_tracks', requestArgs, jwtToken)];
            });
        });
    };
    ApiClient.prototype.createVideoTrack = function (playlistIri, videoIri, jwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createModel('/video_tracks', {
                            playlist: playlistIri,
                            video: videoIri,
                        }, jwtToken)];
                    case 1:
                        response = _a.sent();
                        if (false === response) {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, new video_track_1.VideoTrack(response)];
                }
            });
        });
    };
    ApiClient.prototype.getVideoTrack = function (id, requestArgs, jwtToken) {
        if (requestArgs === void 0) { requestArgs = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getModel("/video_tracks/" + id, requestArgs, jwtToken)];
                    case 1:
                        response = _a.sent();
                        if (null === response) {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, new video_track_1.VideoTrack(response)];
                }
            });
        });
    };
    ApiClient.prototype.deleteVideoTrack = function (id, jwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.deleteModel("/video_tracks/" + id, jwtToken)];
            });
        });
    };
    ApiClient.prototype.updateVideoTracksOrder = function (items, jwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_32;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request('/video_tracks/order', 'PUT', { items: items }, undefined, jwtToken)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, 204 === response.status];
                    case 2:
                        err_32 = _a.sent();
                        if (this.isDebugMode()) {
                            console.log('ERR! apiClient.updateVideoTracksOrder exception', err_32);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    ApiClient.prototype.deleteModel = function (iri, jwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_33;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request(iri, 'DELETE', undefined, undefined, jwtToken)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, 204 === response.status];
                    case 2:
                        err_33 = _a.sent();
                        if (this.isDebugMode()) {
                            console.log('ERR! apiClient.deleteModel exception', err_33);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    ApiClient.prototype.createModel = function (endpoint, payload, jwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_34;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request(endpoint, 'POST', JSON.stringify(__assign({}, payload)), undefined, jwtToken)];
                    case 1:
                        response = _a.sent();
                        if (201 === response.status) {
                            return [2 /*return*/, response.data];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_34 = _a.sent();
                        if (this.isDebugMode()) {
                            console.log('ERR! apiClient.createModel exception', err_34);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    ApiClient.prototype.getRecommendations = function (entityId, jwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_35;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request("/entities/" + entityId + "/recommendations", 'GET', undefined, undefined, jwtToken)];
                    case 1:
                        response = _a.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        if (!response.data['hydra:member']) {
                            throw new Error('API Response is not parseable');
                        }
                        return [2 /*return*/, dataConverter_1.createEntityListFromData(response.data['hydra:member'])];
                    case 2:
                        err_35 = _a.sent();
                        if (this.isDebugMode()) {
                            console.log('ERR! apiClient.getRecommendations exception', err_35);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    ApiClient.prototype.mergeEntities = function (payload) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var response, err_36;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request('/entities/merge', 'POST', JSON.stringify(__assign({}, payload)))];
                    case 1:
                        response = _b.sent();
                        if (200 === response.status) {
                            return [2 /*return*/, !!((_a = response.data) === null || _a === void 0 ? void 0 : _a.success)];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_36 = _b.sent();
                        if (this.isDebugMode()) {
                            console.log('ERR! apiClient.mergeEntities exception', err_36);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    ApiClient.prototype.getModel = function (endpoint, requestArgs, jwtToken) {
        if (requestArgs === void 0) { requestArgs = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var requestQueryString, response, err_37;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        requestQueryString = this.generateRequestString(requestArgs);
                        return [4 /*yield*/, this.request("" + endpoint + requestQueryString, 'GET', undefined, undefined, jwtToken)];
                    case 1:
                        response = _a.sent();
                        if (200 === response.status) {
                            return [2 /*return*/, response.data];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_37 = _a.sent();
                        if (this.isDebugMode()) {
                            console.log('ERR! apiClient.getModel exception', err_37);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, null];
                }
            });
        });
    };
    ApiClient.prototype.getPaginatedModels = function (endpoint, requestArgs, jwtToken) {
        if (requestArgs === void 0) { requestArgs = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var requestQueryString, response, _a, pagesCount, pagePrefix, err_38;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        requestQueryString = this.generateRequestString(requestArgs);
                        return [4 /*yield*/, this.request("" + endpoint + requestQueryString, 'GET', undefined, undefined, jwtToken)];
                    case 1:
                        response = _b.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        if (!this.doesResponseContainMembers(response)) {
                            return [2 /*return*/, {
                                    items: [],
                                    totalEntitiesCount: 0,
                                    pagesCount: 0,
                                    pagePrefix: '',
                                }];
                        }
                        _a = this.parsePageDataFromResponse(response.data), pagesCount = _a.pagesCount, pagePrefix = _a.pagePrefix;
                        return [2 /*return*/, {
                                items: dataConverter_1.createModelListFromData(response.data['hydra:member']),
                                totalEntitiesCount: response.data['hydra:totalItems'] || 0,
                                pagesCount: pagesCount,
                                pagePrefix: pagePrefix,
                            }];
                    case 2:
                        err_38 = _b.sent();
                        this.handleResponseException(err_38);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.getPaginatedEntityChangeRequests = function (requestArgs) {
        if (requestArgs === void 0) { requestArgs = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var requestQueryString, endpoint, response, _a, pagesCount, pagePrefix, err_39;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        requestQueryString = this.generateRequestString(requestArgs);
                        endpoint = "/entity_change_requests" + requestQueryString;
                        return [4 /*yield*/, this.request(endpoint)];
                    case 1:
                        response = _b.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        if (!this.doesResponseContainMembers(response)) {
                            return [2 /*return*/, null];
                        }
                        _a = this.parsePageDataFromResponse(response.data), pagesCount = _a.pagesCount, pagePrefix = _a.pagePrefix;
                        return [2 /*return*/, {
                                items: dataConverter_1.createEntityChangeRequestListFromData(response.data['hydra:member']),
                                totalEntitiesCount: response.data['hydra:totalItems'] || 0,
                                pagesCount: pagesCount,
                                pagePrefix: pagePrefix,
                            }];
                    case 2:
                        err_39 = _b.sent();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.getPaginatedConnectionHistoriesRequests = function (requestArgs) {
        if (requestArgs === void 0) { requestArgs = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var requestQueryString, endpoint, response, _a, pagesCount, pagePrefix, err_40;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        requestQueryString = this.generateRequestString(requestArgs);
                        endpoint = "/connection_histories" + requestQueryString;
                        return [4 /*yield*/, this.request(endpoint)];
                    case 1:
                        response = _b.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        if (!this.doesResponseContainMembers(response)) {
                            return [2 /*return*/, null];
                        }
                        _a = this.parsePageDataFromResponse(response.data), pagesCount = _a.pagesCount, pagePrefix = _a.pagePrefix;
                        return [2 /*return*/, {
                                items: dataConverter_1.createModelListFromData(response.data['hydra:member']),
                                totalEntitiesCount: response.data['hydra:totalItems'] || 0,
                                pagesCount: pagesCount,
                                pagePrefix: pagePrefix,
                            }];
                    case 2:
                        err_40 = _b.sent();
                        if (this.isDebugMode()) {
                            console.log('ERR! apiClient.getPaginatedConnectionHistoriesRequests exception', err_40);
                        }
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.updateAudioPlaylists = function (id, playlists, jwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_41;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request("/audios/" + id + "/playlists", 'PUT', { playlists: playlists }, undefined, jwtToken)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, 200 === response.status];
                    case 2:
                        err_41 = _a.sent();
                        if (this.isDebugMode()) {
                            console.log('ERR! apiClient.updateAudioPlaylists exception', err_41);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    ApiClient.prototype.updateVideoPlaylists = function (id, playlists, jwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_42;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request("/videos/" + id + "/playlists", 'PUT', { playlists: playlists }, undefined, jwtToken)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, 200 === response.status];
                    case 2:
                        err_42 = _a.sent();
                        if (this.isDebugMode()) {
                            console.log('ERR! apiClient.updateVideoPlaylists exception', err_42);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    ApiClient.prototype.getCurrentUser = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_43;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request('/users/me', undefined, undefined, undefined, token)];
                    case 1:
                        response = _a.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, dataConverter_1.createUserFromData(response.data)];
                    case 2:
                        err_43 = _a.sent();
                        this.handleResponseException(err_43);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.updateCurrentUser = function (token, acceptPolicy, newsletter) {
        if (acceptPolicy === void 0) { acceptPolicy = false; }
        if (newsletter === void 0) { newsletter = false; }
        return __awaiter(this, void 0, void 0, function () {
            var data, response, err_44;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        data = { newsletter: newsletter };
                        if (acceptPolicy) {
                            data.acceptPrivacyPolicy = true;
                        }
                        return [4 /*yield*/, this.request('/users/me', 'POST', data, undefined, token)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, 204 !== response.status];
                    case 2:
                        err_44 = _a.sent();
                        this.handleResponseException(err_44);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.unpublishEntity = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_45;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request('/unpublish_entity', 'POST', { id: id })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, 200 === response.status];
                    case 2:
                        err_45 = _a.sent();
                        this.handleResponseException(err_45);
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.getPageContent = function (alias) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_46;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request("/pages/" + alias, 'GET', undefined, undefined, undefined)];
                    case 1:
                        response = _a.sent();
                        if (200 === response.status) {
                            return [2 /*return*/, dataConverter_1.convertPageDataEntities(alias, response.data)];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_46 = _a.sent();
                        if (this.isDebugMode()) {
                            console.log('ERR! apiClient.getPageContent exception', err_46);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, null];
                }
            });
        });
    };
    ApiClient.prototype.updatePageContent = function (alias, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_47;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request("/pages/" + alias, 'PUT', data, undefined, undefined)];
                    case 1:
                        response = _a.sent();
                        if (200 === response.status) {
                            return [2 /*return*/, response.data];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_47 = _a.sent();
                        if (this.isDebugMode()) {
                            console.log('ERR! apiClient.updateStaticContent exception', err_47);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, null];
                }
            });
        });
    };
    ApiClient.prototype.logout = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_48;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request('/logout', 'POST', undefined, undefined, token)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, 204 === response.status];
                    case 2:
                        err_48 = _a.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.login = function (email, password) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_49;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request('/authentication_token', 'POST', JSON.stringify({
                                email: email,
                                password: password,
                            }), undefined, null)];
                    case 1:
                        response = _a.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, response.data.token];
                    case 2:
                        err_49 = _a.sent();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.facebookLogin = function (accessToken) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_50;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request('/facebook_login', 'POST', JSON.stringify({
                                accessToken: accessToken,
                            }), undefined, null)];
                    case 1:
                        response = _a.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, response.data.token];
                    case 2:
                        err_50 = _a.sent();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.getNewsletterBands = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_51;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request('/newsletter/bands', 'GET')];
                    case 1:
                        response = _a.sent();
                        if (200 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, response.data];
                    case 2:
                        err_51 = _a.sent();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.createNewsletterSubscription = function (name, email, city, birthday, bandIds, streamingPlatform, venues, lastConcert, concertFrequency, lastVenue) {
        return __awaiter(this, void 0, void 0, function () {
            var data, response, err_52;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {
                            name: name,
                            email: email,
                            city: city,
                            birthday: birthday,
                            bandIds: bandIds,
                            streamingPlatform: streamingPlatform,
                            venues: venues,
                            lastConcert: lastConcert,
                            concertFrequency: concertFrequency,
                            lastVenue: lastVenue,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.request('/newsletter/subscription', 'POST', data)];
                    case 2:
                        response = _a.sent();
                        if (201 !== response.status) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, true];
                    case 3:
                        err_52 = _a.sent();
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.searchLibrary = function (library, term, page) {
        return __awaiter(this, void 0, void 0, function () {
            var ENDPOINTS, response, err_53;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ENDPOINTS = {
                            fortepan: 'fortepan-image-search',
                            mtva: 'mtva-image-search'
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.request("/" + ENDPOINTS[library] + "?search=" + encodeURIComponent(term) + "&page=" + page, 'GET', undefined, undefined, undefined)];
                    case 2:
                        response = _a.sent();
                        if (200 === response.status) {
                            return [2 /*return*/, response.data];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_53 = _a.sent();
                        if (this.isDebugMode()) {
                            console.log('ERR! apiClient search in image library', err_53);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, null];
                }
            });
        });
    };
    ApiClient.prototype.importFromLibrary = function (library, data) {
        return __awaiter(this, void 0, void 0, function () {
            var ENDPOINTS, err_54;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ENDPOINTS = {
                            fortepan: 'fortepan-image-importer',
                            mtva: 'mtva-image-importer'
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.request("/" + ENDPOINTS[library], 'POST', data, undefined, undefined)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        err_54 = _a.sent();
                        if (this.isDebugMode()) {
                            console.log('ERR! apiClient import from image library', err_54);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, null];
                }
            });
        });
    };
    ApiClient.prototype.request = function (endpoint, method, data, config, jwtToken) {
        if (method === void 0) { method = 'GET'; }
        return __awaiter(this, void 0, void 0, function () {
            var headers, token, response, err_55;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = {
                            'Content-Type': 'application/ld+json',
                        };
                        if (null === jwtToken) {
                            delete axios_1.default.defaults.headers.common.Authorization;
                        }
                        if (null !== jwtToken) {
                            token = jwtToken !== null && jwtToken !== void 0 ? jwtToken : this.jwt;
                            if (token) {
                                headers = __assign(__assign({}, headers), { Authorization: "Bearer " + token });
                            }
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios_1.default.request(__assign(__assign({}, config), { url: "" + this.config.url + endpoint, method: method, data: data, headers: headers }))];
                    case 2:
                        response = _a.sent();
                        if (this.isDebugMode()) {
                            console.log('INFO! apiClient.request was successful', response);
                        }
                        return [2 /*return*/, response];
                    case 3:
                        err_55 = _a.sent();
                        if (err_55.response && err_55.response.status === 403) {
                            this.config.onRequestForbidden(err_55.response, { endpoint: endpoint, method: method, data: data, config: config, jwtToken: jwtToken });
                        }
                        if (this.isDebugMode()) {
                            console.log('ERR! apiClient.request exception', err_55);
                        }
                        throw err_55;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.prototype.handleValidationErrorException = function (err) {
        if (true !== (err === null || err === void 0 ? void 0 : err.isAxiosError)) {
            return null;
        }
        if (err.response && 422 === err.response.status) {
            var errors = dataConverter_1.createValidationErrorsFromResponse(err.response.data);
            if (errors) {
                return new validation_error_response_1.ValidationErrorResponse({ errors: errors });
            }
        }
        return null;
    };
    ApiClient.prototype.handleResponseException = function (err) {
        var _a, _b, _c, _d;
        if (true !== (err === null || err === void 0 ? void 0 : err.isAxiosError)) {
            return;
        }
        if (401 === err.response.status) {
            throw new Error('Unauthorized request');
        }
        if (422 === err.response.status) {
            throw new Error(((_a = err.response.data) === null || _a === void 0 ? void 0 : _a['hydra:description']) || ((_b = err.response.data) === null || _b === void 0 ? void 0 : _b.detail) || err.response.statusText || 'Unkown error');
        }
        if ((_c = err.response.data) === null || _c === void 0 ? void 0 : _c['hydra:description']) {
            throw new Error((_d = err.response.data) === null || _d === void 0 ? void 0 : _d['hydra:description']);
        }
    };
    return ApiClient;
}());
var apiClient = new ApiClient();
exports.default = apiClient;
